import {
  chatMessages,
  chatReadMarkers,
  chatRoomParticipants,
  chatRooms,
} from '../chat'
import { describeTable } from './describeTable'

describeTable(chatRooms, {
  description: `A messaging room. type='customer_service' rooms are the in-app customer chat (resident app "Viestit" ↔ ERP "Viestit"): at most one per customer (customer_id), created lazily on first message and named 'Asiakaspalvelu', with all customer members plus staff as participants. type='group' rooms are internal staff rooms with customer_id NULL. Messages are in chat_messages; a chat_message notification (notifications.notification_type='chat_message') is pushed per message. Low volume compared with email and phone.`,
  columns: {
    type: "'customer_service' = one room per customer for customer ↔ staff chat; 'group' = internal staff group.",
    customerId: 'Customer the room belongs to (unique); NULL for group rooms.',
  },
})

describeTable(chatRoomParticipants, {
  description:
    'Membership of a room; one row per (room, user). Staff members in a customer room have role support.',
  columns: {
    role: "owner = room creator; member = ordinary participant (the customer's people); support = staff answering in a customer_service room.",
  },
})

describeTable(chatMessages, {
  description:
    'One chat message. sender_id is a users row — join users → employees to tell staff from customers (a customer message is one whose sender has no employee row). created_at is the send time; response time in a customer room = first staff message after a customer message. Attachments hang off attachments.chat_message_id.',
  columns: {
    senderId: 'Author (users.id). Staff if the user has an employees row.',
    content: 'Message text.',
  },
})

describeTable(chatReadMarkers, {
  description:
    'Read receipts: a (message, user) row means that user has read up to that message. Operational; not useful for business analysis.',
})
